export default __webpack_public_path__ + "static/media/house-autmn1.8bf912ce.jpg";